<template>
  <v-container class="px-6">
    <h1>Gestão de uploads</h1>
    <p>Acompanhe os status dos uploads dos arquivos.</p>
    <UploadsFilter
      :prestadores="prestadores"
      :operadoras="listOperadora"
      :responsaveis="listResponsaveis"
      :filterList="(formData) => getList(formData, 1)"
      :dataReferencia="dataReferencia"
    />
    <List
      :list="list"
      :pagination="pagination"
      :updatePage="(page)=>getList(filter, page)"
      :deleteDocumentoUpload="(doc) => deleteDocumentoUpload(doc)"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import UploadsFilter from './uploads_monitor/Filter'
import List from './uploads_monitor/List'
export default {
  components: {
    UploadsFilter,
    List
  },
  data() {
    return{
      dataReferencia: null,
      dialog: false,
      filter: null,
      historico: {},
      list: [],
      prestadores: [],
      pagination: {
        limit: 20,
        offset: 1,
        current_page: 1,
        total: null,
        total_pages: 0
      }
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsaveis: (state) => state.faturamento.listResponsavel,
    }),
  },
  watch: {
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadores = this.$store.getters[
          "permissions/getPrestadoresByGeco"
        ]();
      },
    },
  },
  mounted() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    getList(filter, page) {
      this.pagination.current_page = null;
      this.filter = filter
      let limit = this.pagination.limit
      let offset = page? page : this.pagination.offset
      let obj = {
        query: [{ 
          Modulo: "Recebiveis",
          Acao: "getdocumentosupload",
          Payload: {...filter, limit, offset}
        }],
      }
      
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let { dt_inicio, dt_fim } = response
        this.dataReferencia = { dt_inicio, dt_fim }
        this.list = response.dados
        this.pagination.current_page = response.current_page
        this.pagination.offset = response.current_page
        this.pagination.total = response.total
        this.pagination.total_pages = response.total_pages
      })
    },
    deleteDocumentoUpload(doc) {
      let payload = {grupo_economico: this.grupoEconomico, documento_upload_id: doc.id}
      let obj = {query: [{Modulo: "Recebiveis", Acao: "deletedocumentoupload", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {this.getList(this.filter, 1)},
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    }
  }
}
</script>

<style>

</style>